export const OMICALL_SDK_VERSION = '3.0.42';
export const OMICALL_SDK_SRC = `https://cdn.omicrm.com/sdk/web/${OMICALL_SDK_VERSION}/core.min.js`;

export type OmicallRegisterStatus = { status?: boolean; message?: string };

export type OmicallSdk = {
  init: (config: {
    lng?: string;
    ui?: { toggleDial?: 'show' | 'hide'; dialPosition?: 'left' | 'right' };
    searchRemoteContact?: (data: { phone?: string; number?: string }) => Promise<{
      name?: string;
      avatar?: string;
    }>;
  }) => Promise<boolean>;
  register: (creds: {
    sipRealm: string;
    sipUser: string;
    sipPassword: string;
  }) => Promise<OmicallRegisterStatus>;
  unregister: () => void;
  reregister: (state: unknown) => void;
  makeCall: (phone: string, options?: { remoteContact?: { name?: string } }) => void;
  SB_STATE?: { BUSY?: unknown };
};

declare global {
  interface Window {
    OMICallSDK?: OmicallSdk;
  }
}

const SDK_FLAG = 'omi-call-sdk';

export async function loadOmicallSdk(): Promise<OmicallSdk> {
  if (window.OMICallSDK) return window.OMICallSDK;
  if (!document.querySelector(`script[${SDK_FLAG}]`)) {
    await new Promise<void>((resolve, reject) => {
      const el = document.createElement('script');
      el.src = OMICALL_SDK_SRC;
      el.setAttribute(SDK_FLAG, '');
      el.onload = () => resolve();
      el.onerror = () => reject(new Error('OMICallSDK not loaded'));
      document.head.appendChild(el);
    });
  }
  if (!window.OMICallSDK) {
    throw new Error('OMICallSDK not loaded');
  }
  return window.OMICallSDK;
}
